"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFeedbackContext = getFeedbackContext;
const derived_1 = require("../../core/dist/derived");
const feedback_1 = require("../../core/dist/feedback");
async function getFeedbackContext(input, deps) {
    const state = await deps.getState();
    const threadCount = state.weaves.reduce((n, w) => n + w.threads.length, 0);
    const donePlanCount = state.weaves.reduce((n, w) => n + w.threads.reduce((m, t) => m + t.plans.filter(p => p.status === 'done').length, 0), 0);
    const snapshot = {
        loomVersion: input.loomVersion,
        platform: deps.platform(),
        weaveCount: state.weaves.length,
        threadCount,
        donePlanCount,
        currentRelease: (0, derived_1.buildRoadmap)(state).currentRelease,
    };
    const repo = (0, feedback_1.resolveFeedbackRepo)(input.repoOverride);
    return { repo, snapshot, url: (0, feedback_1.buildFeedbackUrl)({ repo, snapshot }) };
}
